import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import GridCellDeal from '../grid-cell-deal'

import ExternalIcon from '../../../../assets/icons/external.svg'

import styles from './grid-cell.css'

const GridCell = ({ dateId, deals, style, timeId, performanceUrl, isOver, color }) => (
  <div style={{ ...style, color }} styleName="cell">
    <div styleName={isOver ? 'content-hover' : 'content-normal'}>
      {deals.map((deal, i) => <GridCellDeal deal={deal} key={i} dateId={dateId} timeId={timeId} />)}
      {performanceUrl &&
        <a href={performanceUrl} styleName="details" target="_blank">
          More details <ExternalIcon styleName="external-icon" />
        </a>
      }
    </div>
  </div>
)

GridCell.propTypes = {
  color: PropTypes.string,
  columnIndex: PropTypes.number.isRequired,
  dateId: PropTypes.string.isRequired,
  deals: PropTypes.object.isRequired,
  isOver: PropTypes.bool.isRequired,
  performanceUrl: PropTypes.string,
  rowIndex: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
  timeId: PropTypes.string.isRequired,
}

export default CSSModules(GridCell, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-cell/grid-cell.js
 **/